import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageRequest } from 'src/app/common/modules/data-table.module/interfaces';
import { ApiResponse } from 'src/app/core/entities/api-response.entity/api-response';
import { ApiService } from 'src/app/core/services/api.service/api.service';
import { Bordearaux } from 'src/app/entities/bordearaux.entity/bordearaux';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DoctorSecretariesService extends ApiService {

  all(): Observable<Array<any>> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary`, { responseType: 'json' }).pipe(this.responsePipe);
  }

  add(userName: string): Observable<any> {
    return this.http.patch<ApiResponse>(`${environment.API_URL}/doctor/secretary/${userName.trim()}`, { responseType: 'json' }).pipe(this.responsePipe);
  }

  delete(userName: string): Observable<any> {
    return this.http.delete<ApiResponse>(`${environment.API_URL}/doctor/secretary/${userName.trim()}`, { responseType: 'json' }).pipe(this.responsePipe);
  }

  getAssistantList(): Observable<Array<any>> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/secretary/medecin-assistants`, { responseType: 'json' }).pipe(this.responsePipe);
  }

  addAssistant(userName: string): Observable<any> {
    return this.http.patch<ApiResponse>(`${environment.API_URL}/doctor/Assistance/${userName.trim()}`, { responseType: 'json' }).pipe(this.responsePipe);
  }
  deleteAssistant(userName: string): Observable<any> {
    return this.http.delete<ApiResponse>(`${environment.API_URL}/doctor/Assistance/${userName.trim()}`, { responseType: 'json' }).pipe(this.responsePipe);
  }
  assistantList(): Observable<Array<any>> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/Assistance`, { responseType: 'json' }).pipe(this.responsePipe);
  }

      paiementStatic(pageRequest: PageRequest, startDate: number, endDate: number,paiement?:boolean): Observable<any> {
        let params = new HttpParams();
        if (pageRequest!.pageOffset) params = params.append("page", pageRequest!.pageOffset);
        if (pageRequest!.pageSize) params = params.append("size", pageRequest!.pageSize);
        if (pageRequest!.sort?.order) {
          // const sortParam = `${pageRequest.sort.key},${pageRequest.sort.order}`;
          let order = 0;
          if (pageRequest.sort.order == "desc") {
            order = 1;
            params = params.append("order", order);
            params = params.append("sortBy", pageRequest.sort.key);
          } else if (pageRequest.sort.order == "asc") {
            order = 0;
            params = params.append("order", order);
            params = params.append("sortBy", pageRequest.sort.key);
          }
        }
        if(!paiement)
        return this.http
          .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/search?before=${startDate}&after=${endDate}`, { params: params })
          .pipe(this.responsePipe);
          else {
             return this.http
          .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/search/by-rdv?before=${startDate}&after=${endDate}`, { params: params })
          .pipe(this.responsePipe);
          }
      }
      searchPaiement(query: string, pageRequest: PageRequest, startDate: number, endDate: number,paiement?:boolean) {
        let params = new HttpParams();
    
        if (query.length != 0) params = params.set("query", query);
        if (pageRequest!.pageOffset) params = params.append("page", pageRequest!.pageOffset);
        if (pageRequest!.pageSize) params = params.append("size", pageRequest!.pageSize);
        if(!paiement)
        return this.http
          .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/search?before=${startDate}&after=${endDate}`, { params: params })
          .pipe(this.responsePipe);
          else {
              return this.http
          .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/search/by-rdv?before=${startDate}&after=${endDate}`, { params: params })
          .pipe(this.responsePipe);
          }
      }
      totalsPaiement(to: number, from: number,paiement?:boolean): Observable<any> {
        let params=new HttpParams()
        params = params.set('from',from);
        params = params.set('to',to)
        if(!paiement)
        return this.http.get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/totals`,{params:params}).pipe(this.responsePipe);
      else {
        return this.http.get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/totals/by-rdv`,{params:params}).pipe(this.responsePipe);
      }
      }
      bordearaux(to: number, from: number): Observable<Bordearaux[]> {
        let params=new HttpParams()
        params = params.set('startDate',from);
        params = params.set('endDate',to)
        return this.http.get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/bordereaux`,{params:params}).pipe(this.responsePipe);
      }
     paiementStaticPatient(pageRequest: PageRequest, startDate: number, endDate: number,paiement?:boolean): Observable<any> {
      let params = new HttpParams();
      if (pageRequest!.pageOffset) params = params.append("page", pageRequest!.pageOffset);
      if (pageRequest!.pageSize) params = params.append("size", pageRequest!.pageSize);
      if (pageRequest!.sort?.order) {
        // const sortParam = `${pageRequest.sort.key},${pageRequest.sort.order}`;
        let order = 0;
        if (pageRequest.sort.order == "desc") {
          order = 1;
          params = params.append("order", order);
          params = params.append("sortBy", pageRequest.sort.key);
        } else if (pageRequest.sort.order == "asc") {
          order = 0;
          params = params.append("order", order);
          params = params.append("sortBy", pageRequest.sort.key);
        }
      }
      if(!paiement)
      return this.http
        .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/totals/by-patient?from=${endDate}&to=${startDate}`, { params: params })
        .pipe(this.responsePipe);
        else {
            return this.http
        .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/totals/by-patient/by-rdv?from=${endDate}&to=${startDate}`, { params: params })
        .pipe(this.responsePipe);
        }
    }
    SearchPaiementByPatient(query: string, pageRequest: PageRequest, startDate: number, endDate: number,paiement?:boolean) {
      let params = new HttpParams();
  
      if (query.length != 0) params = params.set("query", query);
      if (pageRequest!.pageOffset) params = params.append("page", pageRequest!.pageOffset);
      if (pageRequest!.pageSize) params = params.append("size", pageRequest!.pageSize);
      if(!paiement)
      return this.http
        .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/totals/by-patient?from=${endDate}&to=${startDate}`, { params: params })
        .pipe(this.responsePipe);
        else {
            return this.http
        .get<ApiResponse>(`${environment.API_URL}/SecretaryPayments/dashboard/totals/by-patient/by-rdv?from=${endDate}&to=${startDate}`, { params: params })
        .pipe(this.responsePipe);
        }
    }
}
